import React from "react";
import PropTypes from "prop-types";
import Util from "../../../common/util";

function ProfileBio(props) {
  const { bio } = props;

  return (
    <React.Fragment>
      { bio && (
        <div className='row'>
          <div className='col-sm-4'>
            <h3 className='pb-2'>
            自己紹介
            </h3>
          </div>
          <div className='col-sm-8'>
            <p>
              {Util.newLineToBrTag(bio)}
            </p>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

ProfileBio.propTypes = {
  bio: PropTypes.string
};

ProfileBio.defaultProps = {
  bio: null
};

export default ProfileBio;
